import "./TheMoscarielloLegacy.module.css";
import Navigation from "@/reusable_sections/Header";
import Craftsmanship from "./sections/Craftsmanship";
import Timeline from "./sections/Timeline";
import Leadership from "./sections/Leadership";
import Footer from "@/reusable_sections/Footer";
export default function TheMoscarielloLegacyPage() {
  return <div>
      <Navigation />
      <Craftsmanship />
      <Timeline />
      <Leadership />
      <Footer />
    </div>;
}